import { render, staticRenderFns } from "./GrowthStage.vue?vue&type=template&id=f5c185ec&scoped=true"
import script from "./GrowthStage.vue?vue&type=script&lang=js"
export * from "./GrowthStage.vue?vue&type=script&lang=js"
import style0 from "./GrowthStage.vue?vue&type=style&index=0&id=f5c185ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c185ec",
  null
  
)

export default component.exports